<template>
    <div>
        <div class="cover-layer"></div>
        <div class="room-count" ref="hotelPrice">
                <ul>
                    <li @click="RoomCount('10')">不限</li>
                    <li @click="RoomCount('0')">{{Currency}}150以下</li>
                    <li @click="RoomCount('1')">{{Currency}}150-300</li>
                    <li @click="RoomCount('2')">{{Currency}}300-600</li>
                    <li @click="RoomCount('3')">{{Currency}}600-1000</li>
                    <li @click="RoomCount('4')">{{Currency}}1000以上</li>
                </ul>
            </div>
    </div>
</template>

<script>
    export default {
        name: "hotelPrice",
        props:{
            isRoomCountShow:{
                type:Boolean,
                default:false,
            },
            Currency:{
                type:String,
                default:''
            }
        },
        data: function () {
            return {}
        },

        mounted() {
            this.addCloseListener();
        },
        methods: {
            RoomCount(val){
                this.$emit('select',val);
            },
            addCloseListener() {
                let that = this;
                document.addEventListener('click', that.onClick,false);
            },
            onClick(e){
                if (e.target.className == 'room-count' || this.$refs.hotelPrice && this.$refs.hotelPrice.contains(e.target)) return;
                this.$emit('select')
            }
        },
        destroyed(){
            document.removeEventListener('click', this.onClick,false)
        },
    }
</script>

<style scoped>
    .room-count{
        position: absolute;
        top: 49px;
        left: -1px;
        width: 119px;
        border: 1px solid #e6e6e6;
        background: #FFF;
        z-index: 2;
    }
    .room-count ul li{
        padding: 0px 10px;
        cursor: pointer;
        height: 30px;
        line-height: 30px;
    }
    .room-count ul li:hover{
        color: #fff;
        background: #00a0e9;
    }
</style>


// WEBPACK FOOTER //
// src/common/cmpnt/hotelPrice/hotelPrice.vue